<template>
  <div>
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10" ref="tab">
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/3 text-lg text-center text-gray-500 py-4 px-4 font-medium border-transparent cursor-pointer"
          v-for="(item, index) in tabs" :key="index" :class="{ active: active === index }" @click="switchTab(index)">
          {{item}}
        </li>
      </ul>
    </div>
    <div ref="cont">
      <div class="cont1" ref="cont_1">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <!--    标题      -->
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-64 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">临床医学成果转化
            </p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">
            <p class="lg:w-3/4 w-full leading-relaxed text-gray-400 text-sm">
              重点关注以临床应用为导向的科学技术成果并对其进行产业孵化和加速，尤其是科研和临床资源最为丰富的转化医学领域，包括精准医疗、新型治疗方案、创新药、临床技术、智慧医疗等。
            </p>
          </div>
          <!--    内容      -->
          <div class="grid gap-5 sm:grid-cols-1 lg:grid-cols-2 mt-10" style="display: flex;justify-content: center;">
            <div
              class="relative overflow-hidden transition duration-300 transform shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl"
              style="width: 24.125rem;">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/ceil.png'" alt="" />
              <div class="p-6">
                <p class=" mb-4 text-base font-bold leading-5 transition-colors duration-200 block text-center">
                  干细胞治疗
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  聚焦干细胞治疗新技术及创新药物
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  产品适应症包括硬皮病，系统性硬化，皮肤光老化，皮肤老化等
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  团队及专家来自中国顶尖医疗机构
                </p>
              </div>
            </div>
            <div
              class="relative overflow-hidden transition duration-300 transform shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl"
              style="width: 24.125rem;">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/wit.png'" alt="" />
              <div class="p-6">
                <p class=" mb-4 text-base font-bold leading-5 transition-colors duration-200 block text-center">
                  智慧医疗平台
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  首个联手顶尖中国医疗机构打造的以病人为中心的智慧医疗平台
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  形成医疗大数据，并结合人工智能技术
                </p>
                <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass "></div>
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  成为患者和医院之间的线上沟通枢纽，是由患者“管理”到患者“服务”的医疗模式转变的切入点
                </p>
              </div>
            </div>
            <!--              <div class="relative overflow-hidden transition duration-300 transform shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
            <!--                <img class="object-cover w-full contImg" :src="baseOSSUrl + '/robot.png" alt="" />-->
            <!--                <div class="p-6">-->
            <!--                  <p class=" mb-4 text-base font-bold leading-5 transition-colors duration-200 block text-center">-->
            <!--                    磁导航手术机器人-->
            <!--                  </p>-->
            <!--                  <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>-->
            <!--                  <p class="mb-2 text-sm tracking-wider text-gray-400">-->
            <!--                    由中国最著名的心脏病专家领衔-->
            <!--                  </p>-->
            <!--                  <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>-->
            <!--                  <p class="mb-2 text-sm tracking-wider text-gray-400">-->
            <!--                    公司致力于研发并生产新一代心磁导航手术机器人用于心律失常的微创消融-->
            <!--                  </p>-->
            <!--                  <div class="absolute w-2 h-2 bg-gray-200 rounded-full originClass"></div>-->
            <!--                  <p class="mb-2 text-sm tracking-wider text-gray-400">-->
            <!--                    解决传统心脏手术学习时间长、并发症发生率高、劳动强度大等痛点-->
            <!--                  </p>-->
            <!--                </div>-->
            <!--              </div>-->
          </div>
        </div>
      </div>

      <div ref="cont_2">
        <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 lg:pt-24">
          <!--    标题      -->
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-36 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">产业基金</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center">
            <!--            <p class="lg:w-2/3 w-full leading-relaxed text-gray-400 text-sm">-->
            <!--              生命科学园区致力于成为顶尖的R&D垂直平台，依托研究型医院，以GMP实验室、动物房等硬件设施作为支撑，具备驻场CRO，CDMO等服务能力，可在企业起步阶段就为其提供专业的各项服务。-->
            <!--            </p>-->
          </div>
          <div class="container cont2">
            <!-- 内容 -->
            <div class="flex flex-wrap my-10">
              <div class="lg:w-1/4 md:w-1/2">
                <ol class="relative md:my-20">
                  <li class="px-4 pb-10 border-r border-gray-200">
                    <div class="absolute w-3 h-3 roundColor rounded-full -right-1.5"></div>
                    <h3 class="text-base font-semibold titleColor text-right">以临床应用为导向</h3>
                    <p class="mb-4 text-sm font-normal text-gray-500">
                      对以临床应用为导向的科学技术成果进行产业孵化和加速，尤其是科研和临床资源最为丰富的转化医学领域。
                    </p>
                  </li>
                  <li class="px-4 pb-10 border-r border-gray-200">
                    <div class="absolute w-3 h-3 roundColor rounded-full -right-1.5"></div>
                    <h3 class="text-base font-semibold titleColor text-right">深度孵化</h3>
                    <p class="text-sm font-normal text-gray-500">
                      以“深度孵化”为特色，投资生命科学、生物医药、医疗器械、医疗服务等领域的原始创新项目。
                    </p>
                  </li>
                  <li class="px-4 pb-10 ">
                    <div class="absolute w-3 h-3 roundColor rounded-full -right-1.5"></div>
                    <h3 class="text-base font-semibold titleColor text-right">生态系统支撑</h3>
                    <p class="text-sm font-normal text-gray-500 ">
                      依托生命科学园、研究型医院、生物实验室为转化医学提供生态系统支撑。
                    </p>
                  </li>
                </ol>
              </div>
              <div class="lg:w-1/4 md:w-1/2"></div>
              <div class="lg:w-1/4 md:w-1/2"></div>
              <div class="lg:w-1/4 md:w-1/2">
                <ol class="relative md:my-20">
                  <li class="px-4 pb-10 border-l border-gray-200">
                    <div class="absolute w-3 h-3 roundColor rounded-full -left-1.5"></div>
                    <h3 class="text-base font-semibold titleColor ">
                      企业赋能
                    </h3>
                    <p class="mb-4 text-sm font-normal text-gray-500 ">
                      通过丰富的资源网络为被投企业赋能，包括提供商业支持、法律咨询、公司管理及运营支持，政府与顶尖机构的对接等。
                    </p>
                  </li>
                  <!--                  <li class="px-4 pb-10 border-l border-gray-200">-->
                  <!--                    <div class="absolute w-3 h-3 roundColor rounded-full -left-1.5"></div>-->
                  <!--                    <h3 class="text-base font-semibold titleColor ">行业领袖支持</h3>-->
                  <!--                    <p class="text-sm font-normal text-gray-500 ">-->
                  <!--                      -->
                  <!--                    </p>-->
                  <!--                  </li>-->
                  <li class="px-4 pb-10">
                    <div class="absolute w-3 h-3 roundColor rounded-full -left-1.5"></div>
                    <h3 class="text-base font-semibold titleColor">行业领袖支持</h3>
                    <p class="text-sm font-normal text-gray-500 ">
                      紧贴顶级临床技术，由顶尖医疗专家团队组成专家委员会，提供前瞻性、行业引领性的专业意见。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cont3" ref="cont_3">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <!--    标题      -->
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-64 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">生命科学园</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">
            <p class="lg:w-3/4 w-full leading-relaxed text-gray-400 text-sm">
              生命科学园致力于成为领先的产业集聚平台，依托研究型医院，以GMP实验室、动物房等设施作为支撑，具备驻场CRO、CDMO等服务能力，并以产业基金作为抓手，赋能初创、成长型以及龙头企业，构建生命科学领域的生态系统。
            </p>
          </div>

          <!--    内容      -->
          <div class="relative">
            <!--     图片       -->
            <div class="cont3bgImg my-10">
              <div class="box border-gray-400"></div>

            </div>
            <div class="cont3" style="width: 16.875rem;position: absolute;margin-top: -34.625rem;letter-spacing: 1px;">
              <!--              <p class="font-bold">-->
              <!--                飞镖加速器/ATLATL-->
              <!--                <span style="color: #108953;">(已落地)</span>-->
              <!--              </p>-->
              <!--              <div class="text-sm text-gray-400">-->
              <!--                <p class="pt-2">2015年由朱鹏程博士在上海张江创立，为EMHUB的合作实验室；</p>-->
              <!--                <p class="pt-2">实验室是全球最大的Class A级生物医学实验室，内有甲级研发实验室、配套仪器及研发服务，同时拥有专业的运营团队和体系。</p>-->
              <!--              </div>-->
              <p class="font-bold">
                北京干细胞研发中心
              </p>
              <div class="text-sm text-gray-400">
                <p class="pt-2">位于北京大兴自贸区，总建筑面积3500平米；</p>
                <p class="pt-2">集干细胞药物研发、制备、质检及存储功能为一体；</p>
                <p class="pt-2">拥有洁净级别B+A的实验室。</p>
              </div>

            </div>

            <div class="cont3 absolute sm:ml-0"
              style="width: 16.875rem;margin-top: -34.625rem;margin-left: 76%;letter-spacing: 1px;">
              <p class="font-bold">
                粤港澳湾区联合实验室
                <span class="statusColor">(规划中)</span>
              </p>
              <div class="text-sm text-gray-400">
                <p class="pt-2">构建覆盖生物医药领域完整产业链条（GLP-GCP-GMP-GSP）的生命科学园；</p>
                <p class="pt-2">引入财富500强医药、医疗器械企业的区域总部；</p>
                <p class="pt-2">以产业基金为抓手引入创新药、医疗器械企业。</p>
              </div>
            </div>

            <!--            <div class="cont3" style="width: 16.875rem;position: absolute;margin-top: -4rem;letter-spacing: 1px;left: 50%;transform: translate(-50%, -50%);">-->
            <!--              <p class="font-bold">-->
            <!--                瑷格干细胞研发中心-->
            <!--                <span style="color: #108953;">(已落地)</span>-->
            <!--              </p>-->
            <!--              <div class="text-sm text-gray-400">-->
            <!--                <p class="pt-2">位于北京大兴自贸区，总建筑面积3300平米；</p>-->
            <!--                <p class="pt-2">集干细胞药物研发、制备、质检及储存功能为一体；</p>-->
            <!--                <p class="pt-2">拥有洁净级别B+A的实验室。</p>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="cont3" style="width: 16.875rem;position: absolute;margin-top: -20rem;margin-left: 58.125rem;">-->
            <!--              <p class="font-bold">-->
            <!--                青岛联合实验室-->
            <!--                <span class="statusColor">(规划中)</span>-->
            <!--              </p>-->
            <!--              <div class="text-sm text-gray-400">-->
            <!--                以GlP-GSP GMP-GSP为重点发展的生命科学园计划落地青岛市-->
            <!--                与ATLATL和当地伙伴合作-->
            <!--                总建筑面积42000平方米-->
            <!--              </div>-->
            <!--            </div>-->

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    baseOSSUrl
  } from '@/utils/oss';
  export default {
    name: "scienceTabs",
    components: {},
    data() {
      return {
        baseOSSUrl,
        tabs: ["临床医学成果转化", "产业基金", "生命科学园"],
        active: 0,
        cont1: null,
        cont2: null,
        cont3: null,
      }
    },
    props: ['item'],
    methods: {
      switchTab(index) { // 根据当前index切换到对应的页面内容
        if (index === 0) {
          this.active = 0;
          this.cont1.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else if (index === 1) {
          this.active = 1;
          this.cont2.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          this.active = 2;
          this.cont3.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }
    },
    mounted() {
      this.cont1 = this.$refs["cont_1"];
      this.cont2 = this.$refs["cont_2"];
      this.cont3 = this.$refs["cont_3"];
      const tabH = this.$refs["tab"].offsetHeight;
      // 添加scroll事件监听
      window.addEventListener("scroll", () => {
        if (this.cont3.getBoundingClientRect().top <= tabH) {
          this.active = 2;
          return false;
        }
        if (this.cont2.getBoundingClientRect().top <= tabH) {
          this.active = 1;
          return false;
        }
        if (this.cont1.getBoundingClientRect().top <= tabH) {
          this.active = 0;
        }
      });
    },
    destroyed() {
      window.removeEventListener("scroll", () => {}, true)
    },
  }
</script>

<style scoped>
  .active {
    box-sizing: border-box;
    border-bottom-width: 2px;
    border-color: #123B7F;
  }

  .cont1 {
    background-color: #F1F4FB;
  }

  .contImg {
    height: 12.1rem;
  }

  .originClass {
    margin-left: -1rem;
    margin-top: 0.375rem;
    background-color: #123B7F;
  }

  .fundsImg {
    height: 46.375rem;
  }

  .cont2 {
    width: 100%;
    height: 46.375rem;
    background: url('//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/life1.png') no-repeat center;
    background-size: 33.9375rem 33.9375rem;
    /*background: url('../../../assets/images/funds.png') no-repeat center;*/
  }

  .roundColor {
    background-color: #123B7F;
  }

  .titleColor {
    color: #123B7F;
  }

  .cont3 {
    background: #F1F4FB;
  }

  .cont3Content {
    height: 41.3125rem;
  }

  .cont3bgImg {
    width: 100%;
    height: 45.3125rem;
    background: url('//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/life.png') no-repeat center;
    background-size: 33.9375rem 33.9375rem;
    display: flex;
    justify-content: center;
  }

  .box {
    width: 63.9375rem;
    height: 41.3125rem;
    border-width: 0.125rem;
    /*border-color: red;*/
    border-radius: 100%;
    border-style: dashed dashed dashed dashed;
  }

  .statusColor {
    color: #123B7F;
  }
</style>